import React from 'react'
import { string, func, shape, element } from 'prop-types'
import ThemeConsumer from '../ThemeConsumer'
import classNames from 'classnames'
import { MODAL_BUTTON_CLOSE_MODAL_UNTITLED_HEADER } from "shared/constants/idsElements"
import styles from "./styles.css"

const ModalUntitledHeader = ({ theme, icons, onClose }) => (
  <div className={theme.navModalWhite}>
    <button
      id={MODAL_BUTTON_CLOSE_MODAL_UNTITLED_HEADER}
      onClick={onClose}
      className={classNames(styles.cursorPointer, theme.blackBtn)}
    >
      <img src={icons.closeBlack.type} alt="Close" />
    </button>
  </div>
)

ModalUntitledHeader.propTypes = {
  theme: shape({
    blackBtn: string,
    navModalWhite: string,
  }),
  icons: shape({
    close: element,
  }),
  onClose: func.isRequired,
}

ModalUntitledHeader.defaultProps = {
  theme: {},
  icons: {},
}

export default ThemeConsumer('UIModal')(ModalUntitledHeader)



// WEBPACK FOOTER //
// ./src/shared/components/Modal/ModalUntitledHeader.js